import AssetIcon from './AssetIcon'

export default AssetIcon
